import React from "react"
import styles from "./form.module.css"
import View from "../View"
import { navigate } from "@reach/router"


export default ({ handleSubmit, handleUpdate }) => (
 
        <form
          
          className={styles[`form`]}
          
          method="post"
          onSubmit={event => {
            handleSubmit(event)
            navigate(`/portfolio`)

          }}
        >
           <View title="Log In">
          <label className={styles[`form__label`]}>
            Username
            <input
              className={styles[`form__input`]}
              type="text"
              name="username"
              onChange={handleUpdate}
            />
          </label>
          <label className={styles[`form__label`]}>
            Password
            <input
              className={styles[`form__input`]}
              type="password"
              name="password"
              onChange={handleUpdate}
            />
          </label>
          <input className={styles[`form__button`]} type="submit" value="Log In" />
          </View>
        </form>
  
)
